export default __webpack_public_path__ + "static/media/CustomAgentsCapacity_1.a4dd5631.svg";